// Shown in a table cell without a value, so an empty field doesn't look like
// data that hasn't loaded
export const TOM_VERDI = '–';

/** The value for a table cell, or a dash when there is none. */
export const visVerdi = (verdi: string | null | undefined): string =>
    verdi?.trim() ? verdi : TOM_VERDI;
